var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvunja(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 513.99,
    height: 151.323,
    viewBox: "0 0 513.99 151.323",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8099",
    "data-name": "Group 8099",
    transform: "translate(-102.459 -125.839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453",
    transform: "translate(-2505.33 -491.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M212.833,294.154l14.788,8.5-3.6,6.2a7.24,7.24,0,0,1-9.825,2.634l-8.563-4.921,7.2-12.405Z",
    transform: "translate(2416.409 400.28)",
    fill: "#d0021b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M200.829,314.839l2.766-4.765,11.161,6.4,7.692,19.928L214,335.855l-3.11-15.242Z",
    transform: "translate(2416.409 400.28)",
    fill: "#d0021b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M219.053,367.919l-2.433-17.384-4.588-2.633-16.4,6.616a28.1,28.1,0,0,0,23.424,13.4Z",
    transform: "translate(2416.409 400.28)",
    fill: "#d0021b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M193.552,350.406l22.859-7.374-.188-2.823-24.822.755a29.578,29.578,0,0,0,2.151,9.442Z",
    transform: "translate(2416.409 400.28)",
    fill: "#d0021b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M191.38,337.835l16.635.472.433-13.493-10.062-5.772-2.97,5.111a29.915,29.915,0,0,0-4.036,13.682Z",
    transform: "translate(2416.409 400.28)",
    fill: "#d0021b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M263.434,323.207l-14.792-8.5-3.6,6.21a7.157,7.157,0,0,0,2.618,9.774l8.572,4.918,7.2-12.4Z",
    transform: "translate(2416.409 400.28)",
    fill: "#d0021b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M251.429,343.877l2.766-4.768-11.159-6.4-18.521,4.69,4.7,7,11.462-6.7Z",
    transform: "translate(2416.409 400.28)",
    fill: "#d0021b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    d: "M224.079,367.934l-5-23.367,2.55-1.25,11.747,21.753a30.047,30.047,0,0,1-9.3,2.864Z",
    transform: "translate(2416.409 400.28)",
    fill: "#d0021b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M236.116,363.523l-8.725-14.1,11.531-7.116,10.064,5.772-2.972,5.125a30.072,30.072,0,0,1-9.9,10.321Z",
    transform: "translate(2416.409 400.28)",
    fill: "#d0021b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M247.14,312.9l-19.9,18.025-3.456-1.98,5.762-26.2c4.659-1.98,8.8-2.248,11.972-.434,3.185,1.829,5.027,5.559,5.619,10.591Z",
    transform: "translate(2416.409 400.28)",
    fill: "#d0021b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M228.687,249.113c-1.288,2.158-2.486,4.375-3.648,6.59,4.81,2.325,9.569,4.79,14.271,7.332,4.614-.982,9.289-1.9,14.04-2.682,4.525-.729,9.057-1.317,13.6-1.918,1.018-.127.615-.242.069-1.238-1.508-2.758-3-5.54-4.521-8.3q-10.379,3.154-20.618,6.795-6.511-3.439-13.189-6.576Z",
    transform: "translate(2416.409 400.28)",
    fill: "#d0021b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M299.528,234.839a96.136,96.136,0,0,1-15.071,7.047c-4.3,1.468-8.315-2.232-8.069-6.926q.1-2.019.159-4.044l.006-.191c.038-1.775.072-3.557.115-5.335.065-2.38.148-4.764.236-7.145.069-1.637.144-1.665,2.492-1.625a20.248,20.248,0,0,1,12.074,3.746c3.678,2.74,6.531,6.976,8.818,12.094.628,1.4.65,1.607-.76,2.379Z",
    transform: "translate(2416.409 400.28)",
    fill: "#d0021b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M270.958,217.444c.271,8.887.86,17.74,1.485,26.6.041.566.08,1.133.118,1.7.148,2.243-.513,1.748-2.322,2.47-.384.153-.749.308-1.142.446-1.108-2.24-1.963-4.668-2.9-6.995-2.738-6.638-5.536-12.993-8.63-19.471-.071-.163-.151-.323-.228-.485a63.766,63.766,0,0,1,13.621-4.256Z",
    transform: "translate(2416.409 400.28)",
    fill: "#d0021b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M253.021,223.735c1.584,2.565,3.168,5.225,4.721,7.993,1.592,2.831,3.126,5.81,4.669,8.816q-8.48,4.611-16.838,9.479-6.562-3.464-13.354-6.544c1.491-2.229,3.011-4.458,4.654-6.608a48.79,48.79,0,0,1,16.148-13.136Z",
    transform: "translate(2416.409 400.28)",
    fill: "#d0021b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M271.346,311.874c-2.661-1.609-5.3-3.2-7.949-4.814s-5.292-3.208-7.951-4.8c1.689-2.746,3.418-5.468,5.239-8.162,2.991-4.408,8.773-5.852,12.685-3.258,3.42,2.272,6.826,4.562,10.248,6.849-4.086,4.725-8.2,9.439-12.272,14.19Z",
    transform: "translate(2416.409 400.28)",
    fill: "#d0021b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M291.507,288.1c-1.488,1.852-2.983,3.718-4.5,5.543q-6.624-4.537-13.255-9.057c-.35-2.324-3.866-24.106-3.8-24.336.06-.2.867.013,1.133.05,3.271.41,6.52.819,9.782,1.266q-1.107,8.817-2.216,17.437,6.437,4.524,12.855,9.1Z",
    transform: "translate(2416.409 400.28)",
    fill: "#d0021b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M303.461,240.495a174.368,174.368,0,0,1-22.739,7.483q-1.73.479-3.452.982c-2.156.639-1.419.981-1.521,3-.019.384-.032.769-.035,1.159,2.29.235,4.6.235,6.9.3,7.719.215,15.416.637,23.121,1.059a58.494,58.494,0,0,0-2.277-13.982Z",
    transform: "translate(2416.409 400.28)",
    fill: "#d0021b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M305.643,258.9c-3.1-.4-6.3-.83-9.584-1.265-3.329-.435-6.711-.815-10.172-1.2q-1.251,9.047-2.576,17.923c4.02,2.9,8.015,5.839,12.021,8.778,1.529-2.031,3.043-4.076,4.459-6.184a36.634,36.634,0,0,0,5.852-18.051Z",
    transform: "translate(2416.409 400.28)",
    fill: "#d0021b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M264.494,273.551q1.395,2.719,2.777,5.442-1.74,2.625-3.49,5.275c-1.164,1.751-2.328,3.514-3.5,5.274-2.087-.063-4.18-.114-6.271-.165s-4.179-.114-6.272-.165c-.928-1.815-1.85-3.628-2.78-5.442s-1.853-3.615-2.778-5.43q1.749-2.646,3.493-5.276c1.168-1.764,2.332-3.514,3.5-5.275,3.729.089,7.5.153,11.226.281.438.011.875.036,1.313.049.969,1.791,1.863,3.63,2.783,5.432Z",
    transform: "translate(2416.409 400.28)",
    fill: "#d0021b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M216.5,279.81c2.713,1.481,5.428,2.964,8.132,4.472s5.392,3.027,8.085,4.561c1.141-3.194,2.348-6.337,3.777-9.377,2.346-4.993,1.235-10.859-2.893-13.107-3.6-1.954-7.265-3.833-10.953-5.634A133.1,133.1,0,0,0,216.5,279.81Z",
    transform: "translate(2416.409 400.28)",
    fill: "#d0021b",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "avunja-06",
    d: "M83.35,269.014h19.061L93,246.295l-9.65,22.719ZM56.184,292.08,93.2,217.254H94.3l36.2,74.826H112.372l-4.594-10.557H78.324l-4.7,10.557Zm97.873,2.77h-1.191l-34.26-75.34H136.94L154.057,259.2,171.33,219.51h16.982l-34.255,75.34Zm56.484-75.34v39.869q0,9.618,3.537,14.39,3.507,4.783,10.691,4.784c4.6,0,8.115-1.491,10.523-4.46,2.424-2.954,3.637-7.284,3.637-12.955V219.51h15.482v41.628q0,15.708-8.064,24.522-8.045,8.781-22.379,8.779-14.487,0-22.52-8.71t-8.031-24.486V219.51Zm59.772,72.57V217.149h1.66L317.162,259.5V219.51H333.15v75.34h-1.5L286.306,252.5V292.08H270.313Zm71.226-15.167a35.493,35.493,0,0,0,5.059,1.823,15.245,15.245,0,0,0,4.049.636c3.434,0,5.875-1.134,7.346-3.382s2.2-6.087,2.2-11.48v-45H377.62V268.6q0,12.561-6.455,19.21t-18.658,6.627a33.779,33.779,0,0,1-4.6-.313,40.071,40.071,0,0,1-4.711-.887l-1.661-16.327Zm67.125-7.9h19.063l-9.41-22.719-9.653,22.719ZM381.5,292.08l37.021-74.826h1.094l36.2,74.826H437.689l-4.6-10.557H403.636l-4.693,10.557Z",
    transform: "translate(160.633 -38.91)",
    fill: "#010101",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvunja);
export default __webpack_public_path__ + "static/media/avunja.575a3d23aab8af8e8feda3494e64dd65.svg";
export { ForwardRef as ReactComponent };